export default __webpack_public_path__ + "static/media/Picture7.451015d2.png";